import type { LucideIcon } from "lucide-react";
import { Card } from "./Card";

const tones = { blue: "text-blue-500", amber: "text-amber-500", green: "text-emerald-500", slate: "text-slate-500" } as const;

export function Kpi({ label, value, sub, icon: Icon, tone = "slate" }: { label: string; value: string | number; sub: string; icon: LucideIcon; tone?: keyof typeof tones }) {
  return (
    <Card>
      <div className="p-5">
        <div className="flex items-center justify-between mb-3">
          <span className="text-xs font-medium text-slate-400">{label}</span>
          <Icon className={`w-4 h-4 ${tones[tone]}`} />
        </div>
        <div className="text-2xl font-bold">{value}</div>
        <div className="text-[11px] text-slate-400 mt-1">{sub}</div>
      </div>
    </Card>
  );
}
